<template>
  <div id="directions-bottom-bar" class="container white-box">
		<div class="row">

			<div id="directions-signs-btn" class="bottom-bar-btn col-4 noselect" @click="toggleRoadwork();" :class="{ disabled: !showRoadwork }" tabindex="0">

				<div id="directions-signs-active" v-show="showRoadwork" aria-hidden="true">
					<img alt="Vejarbejde ikon" src="https://apps.odenserundt.dk/media/icons/vejarbejde.svg" >
				</div>

				<div id="directions-signs-disabled" v-show="!showRoadwork" aria-hidden="true">
					<img alt="Vejarbejde ikon" src="https://apps.odenserundt.dk/media/icons/vejarbejde_forvarsling.svg">
				</div>

				<span class="bottom-bar-icon-text">Trafikinfo</span>
			</div>

			<div id="directions-parking-btn" class="bottom-bar-btn col-4 noselect" @click="toggleParking();" :class="{ disabled: !showParking }" tabindex="0">
				<div class="directions-parking-icon light-blue" aria-hidden="true">
					<span class="marker-text">P</span>
				</div>
				<span class="bottom-bar-icon-text">Parkering</span>
			</div>

			<div id="directions-public-transport-btn" class="bottom-bar-btn col-4 disabled noselect">
        <a href="https://fynbus.dk/kort/" target="_blank">
  				<span class="material-icons" aria-hidden="true">directions_bus</span>
  				<span class="bottom-bar-icon-text">Bus</span>
        </a>
			</div>

		</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  props: {
    showRoadwork: {
      required: true,
    },
    showParking: {
      required: true,
    },
  },
  methods: {
    toggleRoadwork() {
      this.$emit('toggleRoadwork');
    },
    toggleParking() {
      this.$emit('toggleParking');
    },
  },
}
</script>

<style lang="scss" scoped>
  #directions-bottom-bar {
    position: absolute;
    z-index: 1000;
    bottom: 0px;
    height: 40px;
    width: 100%;
    border-top: 1px solid #dedede;
  }

  @media screen and (min-width: 768px) {
    #directions-bottom-bar {
      top: 10px;
      left: 10px;
      width: 500px;
    }
  }

  .bottom-bar-btn {
    padding: 0;
    text-align: center;
    line-height: 2px;
    height: 100%;
    background-color: white;
    min-width: 50px;
    position: relative;
    display: inline-block;
    vertical-align: top;
    text-shadow: 1px 1px #eee;
    cursor: pointer;
  }

  .bottom-bar-btn.disabled {
    opacity: 0.4;
  }

  .bottom-bar-btn .material-icons {
    font-size: 25px !important;
    margin-bottom: 5px;
  }

  .bottom-bar-icon-text {
    font-size: 12px !important;
    display: block;
  }

  #directions-signs-active img, #directions-signs-disabled img {
    height: 27px;
    width: 27px;
    margin-bottom: 4px;
  }

  .directions-parking-icon {
    position: relative;
    top: 2px;
    left: 50%;
    margin-left: -12px;
    margin-bottom: 6px;
    height: 25px;
    width: 25px;
    border-radius: 4px;
    border: 1px solid #f8f8f8;
  }

  .directions-parking-tutorial-icon {
    position: relative;
    display: inline-block;
    height: 25px;
    width: 25px;
    border-radius: 4px;
    border: 1px solid #f8f8f8;
  }

  .directions-parking-icon .marker-text, .directions-parking-tutorial-icon .marker-text {
    line-height: 25px;
    font-size: 18px;
  }

  #directions-public-transport-btn .material-icons {
    color: #95d450;
  }
</style>
